import casesRoutes from '@/modules/cases/routes';
import globalRoutes from '@/modules/global/routes';
import lawsuitRoutes from '@/modules/lawsuit/routes';
import judicialFeesRoutes from '@/modules/judicialFees/routes';
import bankruptcyRoutes from '@/modules/bankruptcy/routes';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [...globalRoutes, ...lawsuitRoutes, ...casesRoutes, ...judicialFeesRoutes, ...bankruptcyRoutes, {
    path: '/error/403',
    beforeEnter() { location.href = window.location.origin + '/access-denied'; },
  },
  {
    path: '*',
    beforeEnter() { location.href = window.location.origin + '/NotFound'; },
  }],
});

export default router;
